import {
  Icon,
  Items,
  QuarterMenu,
  QuarterOption,
  Select,
  SelectButton,
  Wrapper,
  YearMenu,
  YearOption,
  YearMenuWrapper,
  QuarterMenuWrapper
} from './style';
import ArrowRight from '../../../../../assets/icons/arrow-right.svg?react';
import { Popover } from 'react-tiny-popover';
import { useState } from 'react';

const periodOptions = ['Q1', 'Q2', 'Q3', 'Q4', 'H1', 'H2', 'Y1', 'X1', 'X2'] as const;

interface ReportPeriodCardProps {
  quarter: string;
  year: number | string;
  changeQuarter: (value: string) => void;
  changeYear: (value: number) => void;
  hideTitle?: boolean;
  isDisabled?: boolean;
  placeholder?: string;
}

export function ReportPeriodCard({
  quarter,
  year,
  changeQuarter,
  changeYear,
  hideTitle = false,
  isDisabled
}: ReportPeriodCardProps) {
  const [isOpenQuarter, setIsOpenQuarter] = useState<boolean>(false);
  const [isOpenYear, setIsOpenYear] = useState<boolean>(false);

  const handleQuarterSelect = (item: string) => () => {
    changeQuarter(item);
    setIsOpenQuarter(false);
  };

  const handleToggleQuarter = () => {
    if (!isDisabled) setIsOpenQuarter(prev => !prev);
  };

  const handleYearSelect = (yearValue: number) => () => {
    changeYear(yearValue);
    setIsOpenYear(false);
  };

  const handleToggleYear = () => {
    if (!isDisabled) setIsOpenYear(prev => !prev);
  };

  return (
    <Wrapper>
      {!hideTitle && <p>Reporting Period</p>}
      <Items>
        <Select>
          <label>Select period</label>
          <Popover
            isOpen={isOpenQuarter}
            onClickOutside={() => setIsOpenQuarter(false)}
            positions="bottom"
            padding={10}
            transitionDuration={300}
            containerStyle={{
              width: '343px'
            }}
            content={
              <QuarterMenuWrapper>
                <QuarterMenu>
                  {periodOptions.map(item => (
                    <QuarterOption
                      key={item}
                      isActive={quarter === item}
                      onClick={handleQuarterSelect(item)}
                    >
                      {item}
                    </QuarterOption>
                  ))}
                </QuarterMenu>
              </QuarterMenuWrapper>
            }
          >
            <SelectButton onClick={handleToggleQuarter}>
              <p>{quarter || ''}</p>
              <Icon isOpen={isOpenQuarter}>
                <ArrowRight />
              </Icon>
            </SelectButton>
          </Popover>
        </Select>
        <Select>
          <label>Select year</label>
          <Popover
            isOpen={isOpenYear}
            onClickOutside={() => setIsOpenYear(false)}
            positions={['bottom', 'top', 'left', 'right']}
            padding={10}
            containerStyle={{
              width: '161px'
            }}
            content={
              <YearMenuWrapper>
                <YearMenu>
                  <YearOption isActive={year === 2025} onClick={handleYearSelect(2025)}>
                    2026
                  </YearOption>
                  <YearOption isActive={year === 2025} onClick={handleYearSelect(2025)}>
                    2025
                  </YearOption>
                  <YearOption isActive={year === 2024} onClick={handleYearSelect(2024)}>
                    2024
                  </YearOption>
                  <YearOption isActive={year === 2023} onClick={handleYearSelect(2023)}>
                    2023
                  </YearOption>
                  <YearOption isActive={year === 2022} onClick={handleYearSelect(2022)}>
                    2022
                  </YearOption>
                </YearMenu>
              </YearMenuWrapper>
            }
          >
            <SelectButton onClick={handleToggleYear}>
              <p>{year || ''}</p>
              <Icon isOpen={isOpenYear}>
                <ArrowRight />
              </Icon>
            </SelectButton>
          </Popover>
        </Select>
      </Items>
    </Wrapper>
  );
}
